// import "./productStyle.css";
// import ProductPic from "../../../img/smaPicCart.png";
// import { HandySvg } from "handy-svg";
// import iconSrc from "../../../svg/howSay.svg";
// import iconSrcCard from "../../../svg/cardHowSay.svg";
// import { Link, NavLink } from "react-router-dom";
// import addToCart from "../../../function/addToCard";
// import { useEffect, useState } from "react";
// import transliterate from "../../../function/transliterate";
// import { PhotoProvider, PhotoSlider, PhotoView } from "react-photo-view";
// import { getProductHref } from "../../../function/productLink";
// export default function ProductNewReview({
//   el,
//   setAddressChanged,
//   setCartCounterC,
//   setLikeCounterC,
// }) {
//   const [liked, setLiked] = useState(false);
//   const addingToCart = (id) => {
//     addToCart(id);

//     setCartCounterC((prev) => prev + 1);
//   };
//   const handleLike = () => {
//     // Отримуємо дані з localStorage
//     let likedProducts = JSON.parse(localStorage.getItem("likedProducts")) || [];

//     if (!liked) {
//       // Додаємо товар до масиву подобається
//       setLikeCounterC((prev) => prev + 1);
//       likedProducts.push(el);
//     } else {
//       setLikeCounterC((prev) => prev + 1);
//       // Видаляємо товар з масиву подобається
//       const updatedLikedProducts = likedProducts.filter(
//         (product) => product.uid !== el.uid,
//       );
//       likedProducts = updatedLikedProducts;
//     }

//     // Зберігаємо оновлений масив у localStorage
//     localStorage.setItem("likedProducts", JSON.stringify(likedProducts));

//     // Змінюємо стан liked
//     setLiked(!liked);
//   };
//   useEffect(() => {
//     // Отримуємо дані з localStorage
//     const likedProducts =
//       JSON.parse(localStorage.getItem("likedProducts")) || [];

//     // Перевіряємо, чи товар є в масиві подобається
//     const isLiked = likedProducts.some((product) => product.uid === el.uid);

//     // Встановлюємо відповідний стан liked
//     setLiked(isLiked);
//   }, []);
//   const isTopBook =
//     el?.top === "true" ||
//     el?.top === true ||
//     el?.topMonth === "true" ||
//     el?.topMonth === true;

//   const isNewBook =
//     el?.novunka === "true" ||
//     el?.novunka === true ||
//     el?.isNew === "true" ||
//     el?.isNew === true;
//   return (
//     <div className="smallProductWrap">
//       {/* <img src={el.imageList[0]} className="productPicSmall" /> */}
//       <PhotoProvider>
//         <PhotoView src={el.imageList[0]}>
//           <img
//             src={el.imageList[0]}
//             alt={`${el.bookName}`}
//             className="productPicSmall"
//           />
//         </PhotoView>
//         {/* Додаємо всі зображення до PhotoView для перегляду в повноекранному режимі */}
//         {el.imageList.map((item, index) => (
//           <PhotoView key={index} src={item}>
//             <span style={{ display: "none" }} />
//           </PhotoView>
//         ))}
//       </PhotoProvider>
//       {isTopBook && <div className="smallTopBookLabel">ТОП місяця</div>}

//       {isNewBook && <div className="smallNewBookLabel">Новинка</div>}
//       <div className="prodPricLikeCart">
//         <div className="prdeProdPricingCatalogSale">
//           <div className="prdeProdPricingRotateCart">
//             <p className="salePriceCartSale">{el.price}</p>
//             <p className="fullPriceCart">грн</p>
//           </div>
//         </div>
//         <div className="likeCardWrapSmall">
//           <div
//             className={`likeProductSmallCatalog${liked ? "Click" : ""}`}
//             onClick={handleLike}
//           >
//             <HandySvg src={iconSrc} width="34" height="31" />
//           </div>
//           <div className="likeProductSmallCatalog">
//             <HandySvg
//               src={iconSrcCard}
//               width="28.33"
//               height="28.33"
//               onClick={() => addingToCart(el.uid)}
//             />
//           </div>
//         </div>
//       </div>
//       <h2 className="smallProdNameSaleYouLike">
//         <Link
//           className="smallProdNameSaleYouLike"
//           to={getProductHref(el)}
//           onClick={() => setAddressChanged(true)}
//         >
//           {el.bookName}
//         </Link>
//       </h2>

//       <div className="autorInformCart">
//         <div className="autorInformSectionCart">
//           <p className="porodForCatP">
//             {" "}
//             Автор:&nbsp;<span className="porodForCatPSpan">{el.textAutor}</span>
//           </p>
//         </div>
//         <div className="autorInformSectionCart">
//           <p className="porodForCatP">
//             Художник:&nbsp;
//             <span className="porodForCatPSpan">{el.picWriter}</span>
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }
import "./productStyle.css";
import { HandySvg } from "handy-svg";
import iconSrc from "../../../svg/howSay.svg";
import iconSrcCard from "../../../svg/cardHowSay.svg";
import { Link } from "react-router-dom";
import addToCart from "../../../function/addToCard";
import { useEffect, useState } from "react";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { getProductHref } from "../../../function/productLink";

export default function ProductNewReview({
  el,
  setAddressChanged,
  setCartCounterC,
  setLikeCounterC,
}) {
  const [liked, setLiked] = useState(false);

  const addingToCart = (id) => {
    addToCart(id);
    setCartCounterC((prev) => prev + 1);
  };

  const handleLike = () => {
    let likedProducts = JSON.parse(localStorage.getItem("likedProducts")) || [];

    if (!liked) {
      setLikeCounterC((prev) => prev + 1);
      likedProducts.push(el);
    } else {
      setLikeCounterC((prev) => prev + 1);

      const updatedLikedProducts = likedProducts.filter(
        (product) => product.uid !== el.uid,
      );

      likedProducts = updatedLikedProducts;
    }

    localStorage.setItem("likedProducts", JSON.stringify(likedProducts));
    setLiked(!liked);
  };

  useEffect(() => {
    const likedProducts =
      JSON.parse(localStorage.getItem("likedProducts")) || [];

    const isLiked = likedProducts.some((product) => product.uid === el.uid);

    setLiked(isLiked);
  }, [el.uid]);

  const isTopBook =
    el?.top === "true" ||
    el?.top === true ||
    el?.topMonth === "true" ||
    el?.topMonth === true;

  const isNewBook =
    el?.novunka === "true" ||
    el?.novunka === true ||
    el?.isNew === "true" ||
    el?.isNew === true;

  const hasValue = (value) => {
    if (value === null || value === undefined) return false;

    return String(value).trim().length > 0;
  };

  const getPriceInfo = (product) => {
    const basePrice = product?.price;

    // Передпродаж / стара ціна в товарі.
    // У твоїй логіці priceSale — це стара ціна, а price — актуальна.
    if (hasValue(product?.priceSale)) {
      return {
        hasDiscount: true,
        oldPrice: product.priceSale,
        currentPrice: basePrice,
        discountPercent: null,
        type: "preorder",
      };
    }

    // Розпродаж
    if (hasValue(product?.salePrice)) {
      return {
        hasDiscount: true,
        oldPrice: basePrice,
        currentPrice: product.salePrice,
        discountPercent: product.saleDiscountPercent,
        type: "sale",
      };
    }

    // Акція
    if (hasValue(product?.actionPrice)) {
      return {
        hasDiscount: true,
        oldPrice: basePrice,
        currentPrice: product.actionPrice,
        discountPercent: product.actionDiscountPercent,
        type: "action",
      };
    }

    return {
      hasDiscount: false,
      oldPrice: null,
      currentPrice: basePrice,
      discountPercent: null,
      type: "default",
    };
  };

  const renderPrice = () => {
    const priceInfo = getPriceInfo(el);

    if (priceInfo.hasDiscount) {
      return (
        <div className="prdeProdPricingCatalogSale prdeProdPricingCatalogDiscount">
          <div className="prdeProdPricingRotateCart">
            {hasValue(priceInfo.discountPercent) && (
              <p className="discountPercentSmall">
                -{priceInfo.discountPercent}%
              </p>
            )}

            <p className="oldPriceCartSmall">{priceInfo.oldPrice}</p>

            <p className="salePriceCartSale">{priceInfo.currentPrice}</p>

            <p className="fullPriceCart">грн</p>
          </div>
        </div>
      );
    }

    return (
      <div className="prdeProdPricingCatalogSale">
        <div className="prdeProdPricingRotateCart">
          <p className="salePriceCartSale">{priceInfo.currentPrice}</p>
          <p className="fullPriceCart">грн</p>
        </div>
      </div>
    );
  };

  if (!el) return null;

  return (
    <div className="smallProductWrap">
      <PhotoProvider>
        {Array.isArray(el.imageList) && el.imageList[0] && (
          <PhotoView src={el.imageList[0]}>
            <img
              src={el.imageList[0]}
              alt={`${el.bookName}`}
              className="productPicSmall"
            />
          </PhotoView>
        )}

        {Array.isArray(el.imageList) &&
          el.imageList.map((item, index) => (
            <PhotoView key={index} src={item}>
              <span style={{ display: "none" }} />
            </PhotoView>
          ))}
      </PhotoProvider>

      {isTopBook && <div className="smallTopBookLabel">ТОП місяця</div>}

      {isNewBook && <div className="smallNewBookLabel">Новинка</div>}

      <div className="prodPricLikeCart">
        {renderPrice()}

        <div className="likeCardWrapSmall">
          <div
            className={`likeProductSmallCatalog${liked ? "Click" : ""}`}
            onClick={handleLike}
          >
            <HandySvg src={iconSrc} width="34" height="31" />
          </div>

          <div className="likeProductSmallCatalog">
            <HandySvg
              src={iconSrcCard}
              width="28.33"
              height="28.33"
              onClick={() => addingToCart(el.uid)}
            />
          </div>
        </div>
      </div>

      <h2 className="smallProdNameSaleYouLike">
        <Link
          className="smallProdNameSaleYouLike"
          to={getProductHref(el)}
          onClick={() => setAddressChanged(true)}
        >
          {el.bookName}
        </Link>
      </h2>

      <div className="autorInformCart">
        <div className="autorInformSectionCart">
          <p className="porodForCatP">
            Автор:&nbsp;
            <span className="porodForCatPSpan">{el.textAutor}</span>
          </p>
        </div>

        <div className="autorInformSectionCart">
          <p className="porodForCatP">
            Художник:&nbsp;
            <span className="porodForCatPSpan">{el.picWriter}</span>
          </p>
        </div>
      </div>
    </div>
  );
}
